/**
 * Home live-slot hydrator. The initial server render is already live (real counts, final
 * structure) except for stats that are expensive/side-effectful to compute inline (the
 * analytics stat, always) or that happened to exceed the server's soft render deadline on this
 * particular request (any other tile/card/stat, occasionally). Those render as [data-live-slot]
 * skeletons; this fetches /dashboard/modules and replaces each matching slot IN PLACE.
 *
 * Never replace the whole region: a wholesale innerHTML swap lands mid-entrance-stagger and
 * cuts the animation (the "flash" bug), and re-mounting identical DOM is pure churn. Slot
 * replacement cannot flash — everything outside the slots is untouched.
 *
 * Contract with _DashboardHomeRegion.cshtml / _DashboardQuietRow.cshtml:
 * #dash-modules-region, data-modules-url, data-live-slot. On failure, skeletons stay.
 */
(function () {
  "use strict";

  function init() {
    var region = document.getElementById("dash-modules-region");
    if (!region) return;

    var url = region.getAttribute("data-modules-url");
    if (!url) return;

    // Only slots that still show a skeleton need hydration; if the server rendered
    // everything (or there are no slots), skip the request entirely.
    var pending = region.querySelectorAll("[data-live-slot] .ui-skeleton");
    if (pending.length === 0) return;

    fetch(url, { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("modules request failed: " + res.status);
        return res.text();
      })
      .then(function (html) {
        if (!html || html.trim().length === 0) return;
        var tpl = document.createElement("template");
        tpl.innerHTML = html;
        region.querySelectorAll("[data-live-slot]").forEach(function (slot) {
          var key = slot.getAttribute("data-live-slot");
          var fresh = tpl.content.querySelector('[data-live-slot="' + key + '"]');
          if (fresh) slot.replaceWith(fresh);
        });
      })
      .catch(function () {
        // Keep the skeleton slots.
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
